module.exports = __webpack_public_path__ + "10dba709647d78338c9b2dfb17a920c4.svg";